import { PropsWithChildren } from 'react';
import React from 'react';
import { View, useWindowDimensions } from 'react-native';

export const AppRoot = ({ children }: PropsWithChildren) => {
    const { height } = useWindowDimensions();
    return <View style={{ height }}>{children}</View>;
};
